<div #container [style.width]="hostWidth" [style.height]="hostHeight"></div>
<ng-content></ng-content>
